module.exports = __webpack_public_path__ + "img/dashboard.28a2a850.svg";